(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["marquee"] && !Shopify.designMode) return;
  try {
    class MarqueeBlock extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-marquee-track]');
      this.run = this.querySelector('[data-marquee-run]');
      if (!this.track || !this.run) return;

      this.sourceHTML = this.run.innerHTML;
      this.build();

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.scheduleBuild());
        this.observer.observe(this);
      } else {
        this.onResize = () => this.scheduleBuild();
        window.addEventListener('resize', this.onResize);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.scheduleBuild());
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      clearTimeout(this.timer);
    }

    scheduleBuild() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.build(), 200);
    }

    build() {
      if (!this.sourceHTML.trim()) return;
      if (this.dataset.animateOn === 'never') {
        this.setAttribute('data-ready', '');
        return;
      }

      const clone = this.track.querySelector('.block-marquee__run[aria-hidden="true"]');
      if (clone) clone.remove();
      this.run.innerHTML = this.sourceHTML;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const available = this.clientWidth;
      if (!available) return;

      const items = Array.from(this.run.children);
      let guard = 0;
      while (this.run.scrollWidth < available && items.length && guard < 50) {
        for (const item of items) this.run.appendChild(this.copy(item));
        guard += 1;
      }

      const runWidth = this.run.getBoundingClientRect().width;
      if (!runWidth) return;

      const second = this.run.cloneNode(true);
      second.setAttribute('aria-hidden', 'true');
      second.removeAttribute('data-marquee-run');
      this.stripEditorAttributes(second);
      this.track.appendChild(second);

      const speed = parseFloat(this.dataset.speed) || 40;
      this.style.setProperty('--marquee-duration', (runWidth + gap) / speed + 's');
      this.setAttribute('data-ready', '');
    }

    copy(node) {
      const item = node.cloneNode(true);
      item.setAttribute('aria-hidden', 'true');
      this.stripEditorAttributes(item);
      return item;
    }

    stripEditorAttributes(node) {
      const nodes = [node].concat(Array.from(node.querySelectorAll('[id], [data-shopify-editor-block]')));
      for (const el of nodes) {
        el.removeAttribute('id');
        el.removeAttribute('data-shopify-editor-block');
      }
    }
  }

  if (!customElements.get('marquee-block')) {
    customElements.define('marquee-block', MarqueeBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["slideshow"] && !Shopify.designMode) return;
  try {
    let swiperLoader = null;

  function loadSwiper(src) {
    if (window.Swiper) return Promise.resolve();
    if (swiperLoader) return swiperLoader;

    swiperLoader = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return swiperLoader;
  }

  class SlideshowBlock extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.swiper');
      if (!this.viewport) return;

      const slides = this.viewport.querySelectorAll('.swiper-wrapper > *');
      if (slides.length < 2) return;

      loadSwiper(this.dataset.swiperSrc)
        .then(() => this.init())
        .catch(() => {
        });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    init() {
      if (!window.Swiper || !this.isConnected) return;
      if (this.swiper) this.swiper.destroy(true, true);

      const slides = this.viewport.querySelectorAll('.swiper-wrapper > *');
      for (const slide of slides) {
        slide.classList.add('swiper-slide');
      }

      const perView = parseFloat(this.dataset.perView) || 1;
      const perViewMobile = parseFloat(this.dataset.perViewMobile) || 1;
      const spaceBetween = parseInt(this.dataset.spaceBetween, 10) || 0;
      const bySlideWidth = this.dataset.slideSizing === 'width';
      const slideWidth = parseInt(this.dataset.slideWidth, 10) || 320;

      const desktopPerView = bySlideWidth ? 'auto' : perView;

      const centered = this.dataset.centered === 'true';
      const wantsLoop = this.dataset.infinite === 'true';
      const scaled = this.classList.contains('block-slideshow--scale-inactive');

      let onScreen = bySlideWidth
        ? Math.ceil(this.viewport.clientWidth / (slideWidth + spaceBetween)) + 1
        : Math.ceil(perView);
      onScreen = Math.max(onScreen, Math.ceil(perViewMobile));
      if (centered && onScreen % 2 === 0) onScreen += 1;
      const spare = Math.max(0, Math.min(2, slides.length - onScreen - 1));
      const canLoop = wantsLoop && slides.length >= onScreen + 1 + spare;

      const options = {
        speed: 600,
        loop: canLoop,
        rewind: wantsLoop && !canLoop,
        loopAdditionalSlides: spare,
        grabCursor: true,
        a11y: { enabled: true },
        slidesPerView: perViewMobile,
        spaceBetween: spaceBetween,
        centeredSlides: centered,
        maxBackfaceHiddenSlides: scaled ? 0 : 10,
        autoHeight: this.dataset.autoHeight === 'true' && perView === 1 && !bySlideWidth,
        breakpoints: { 750: { slidesPerView: desktopPerView, spaceBetween: spaceBetween } },
      };

      if (this.dataset.effect === 'fade' && perView === 1 && perViewMobile === 1 && !bySlideWidth) {
        options.effect = 'fade';
        options.fadeEffect = { crossFade: true };
      }

      if (this.dataset.autoplay === 'true') {
        options.autoplay = {
          delay: parseInt(this.dataset.interval, 10) || 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      if (this.dataset.pagination === 'true') {
        options.pagination = { el: this.querySelector('.swiper-pagination'), clickable: true };
      }

      if (this.dataset.arrows === 'true') {
        options.navigation = {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        };
      }

      this.swiper = new window.Swiper(this.viewport, options);
    }
  }

  if (!customElements.get('slideshow-block')) {
    customElements.define('slideshow-block', SlideshowBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
